import { lightFormat } from 'date-fns';

import { FIELD_KEYS } from '_constants/forms';
import { FILTER_TYPES, MERGE_TYPES, REPORT_KEYS } from '_constants/reports';
import { RECONCILE_STATUS } from '_constants/transactions';

const FILTER_TYPES_MAP = {
  [FILTER_TYPES.monthToDate]: MERGE_TYPES.date,
  [FILTER_TYPES.lastMonth]: MERGE_TYPES.date,
  [FILTER_TYPES.lastThreeMonth]: MERGE_TYPES.month,
  [FILTER_TYPES.yearToDate]: MERGE_TYPES.month,
  [FILTER_TYPES.dateRange]: MERGE_TYPES.date,
  [FILTER_TYPES.monthRange]: MERGE_TYPES.month,
};

const createExpensesGraphParamsFromFilters = (filters = {}) => {
  const params = {
    [FIELD_KEYS.mergeTo]: FILTER_TYPES_MAP[filters[FIELD_KEYS.filterType]],
    [FIELD_KEYS.from]: lightFormat(filters[FIELD_KEYS.dateRangeFrom], 'yyyy-MM-dd'),
    [FIELD_KEYS.to]: lightFormat(filters[FIELD_KEYS.dateRangeTo], 'yyyy-MM-dd'),
  };

  return params;
};

const createIncomeGraphParamsFromFilters = (filters = {}) => {
  const params = {
    [FIELD_KEYS.mergeTo]: FILTER_TYPES_MAP[filters[FIELD_KEYS.filterType]],
    [FIELD_KEYS.from]: lightFormat(filters[FIELD_KEYS.dateRangeFrom], 'yyyy-MM-dd'),
    [FIELD_KEYS.to]: lightFormat(filters[FIELD_KEYS.dateRangeTo], 'yyyy-MM-dd'),
  };

  return params;
};

const createInsightsGraphParamsFromFilters = (filters = {}) => {
  const params = {
    [FIELD_KEYS.mergeTo]: FILTER_TYPES_MAP[filters[FIELD_KEYS.filterType]],
    [FIELD_KEYS.type]: filters[FIELD_KEYS.type],
    [FIELD_KEYS.from]: lightFormat(filters[FIELD_KEYS.dateRangeFrom], 'yyyy-MM-dd'),
    [FIELD_KEYS.to]: lightFormat(filters[FIELD_KEYS.dateRangeTo], 'yyyy-MM-dd'),
  };

  return params;
};

const createBankTransactionsParamsFromFilters = (filters = {}) => {
  const params = {
    [FIELD_KEYS.from]: lightFormat(filters[FIELD_KEYS.from], 'yyyy-MM-dd'),
    [FIELD_KEYS.to]: lightFormat(filters[FIELD_KEYS.to], 'yyyy-MM-dd'),
    [FIELD_KEYS.page]: 1,
    [FIELD_KEYS.count]: 25,
    isReconcile: null,
  };

  if (filters[FIELD_KEYS.reconcile] === RECONCILE_STATUS.reconciled) {
    params.isReconcile = true;
  }

  if (filters[FIELD_KEYS.reconcile] === RECONCILE_STATUS.unreconciled) {
    params.isReconcile = false;
  }

  return params;
};

export const createParamsFromFilters = (reportKey, filters = {}) => {
  const MAP = {
    [REPORT_KEYS.expensesGraph]: createExpensesGraphParamsFromFilters,
    [REPORT_KEYS.incomeGraph]: createIncomeGraphParamsFromFilters,
    [REPORT_KEYS.insightsGraph]: createInsightsGraphParamsFromFilters,
    [REPORT_KEYS.bankTransactions]: createBankTransactionsParamsFromFilters,
  };

  const creator = MAP[reportKey];

  return creator ? creator(filters) : {};
};

export const createParamsPayload = (filtersPayload = {}) => {
  return Object.keys(filtersPayload).reduce((paramsPayload, reportKey) => {
    paramsPayload[reportKey] = createParamsFromFilters(reportKey, filtersPayload[reportKey]);
    return paramsPayload;
  }, {});
};
